import { ComboboxTagItem, ComboboxTagItemProps } from '@sib/ui';
import { EditingTag } from '@sib/utils';

interface ComboboxTagOptionProps extends Omit<ComboboxTagItemProps, 'onEdit'> {
  onEdit?: (value: EditingTag) => void;
}

export const ComboboxTagOption = ({
  onEdit,
  ...props
}: ComboboxTagOptionProps) => (
  <ComboboxTagItem
    {...props}
    {...(onEdit && {
      onEdit: tag =>
        onEdit({
          uuid: tag.value,
          name: tag.label as string,
          color: tag.color,
        }),
    })}
  />
);
